import {ChangeDetectionStrategy, Component, EventEmitter, Output} from '@angular/core';
import {DashboardStudyViewerZoomedControlsSliceNamePipe} from '../../pipes/dashboard-study-viewer-zoomed-controls-slice-name/dashboard-study-viewer-zoomed-controls-slice-name.pipe';
import {OriginalPapayaViewerSlice} from '../../../dashboard-study-papaya/types/dashboard-study-papaya-original.types';
import {DashboardStudyPapayaControllerService} from '../../../dashboard-study-papaya/services/dashboard-study-papaya-controller/dashboard-study-papaya-controller.service';

@Component({
  selector: 'app-dashboard-study-viewer-zoomed-controls-slice',
  templateUrl: './dashboard-study-viewer-zoomed-controls-slice.component.html',
  styleUrls: ['./dashboard-study-viewer-zoomed-controls-slice.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DashboardStudyViewerZoomedControlsSliceNamePipe],
})
export class DashboardStudyViewerZoomedControlsSliceComponent {
  /** The order of the slices in the thumbnail. */
  public readonly sliceOrder = [OriginalPapayaViewerSlice.Axial, OriginalPapayaViewerSlice.Coronal, OriginalPapayaViewerSlice.Sagittal];

  /** The current slice index. */
  public currentSliceIndex = 0;

  /** The currently selected slice. */
  @Output() selectedSlice = new EventEmitter<OriginalPapayaViewerSlice>();

  constructor(private papayaController: DashboardStudyPapayaControllerService) {}

  /**
   * Reorders the views to the previous slice.
   */
  public previousSlice(): void {
    this.currentSliceIndex = this.currentSliceIndex - 1 < 0 ? 2 : this.currentSliceIndex - 1;
    this.papayaController.reorderViewsToSpecificPosition(this.sliceOrder[this.currentSliceIndex], true);
    this.selectedSlice.emit(this.sliceOrder[this.currentSliceIndex]);
  }

  /**
   * Reorders the views to the next slice.
   */
  public nextSlice(): void {
    this.currentSliceIndex = this.currentSliceIndex + 1 > 2 ? 0 : this.currentSliceIndex + 1;
    this.papayaController.reorderViewsToSpecificPosition(this.sliceOrder[this.currentSliceIndex], true);
    this.selectedSlice.emit(this.sliceOrder[this.currentSliceIndex]);
  }
}
